<div class="card-panel">
    <div class="card-body" [ngClass]="backgroundColor">
        <ng-content></ng-content>
    </div>
</div>
